import { Chart } from "chart.js";
import { datalabelFont, legendConfig, legendPad, onResize, tooltipTitleFont, legendOffsetPlugin } from "./chartJsPlugins";
import { htmlLegendPlugin, generateChartId, getContrastColor } from "./configs";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { infoBubble } from "../../helpers/infoBubble";
import { fillMissingData, IarMetricSampleRow, upperizeStringify } from "./chartUtils";
import { metricChartSelectorSubscription, createChartFilterStore } from "../../helpers/charts-helper";

interface ChartsSettings {
    demographic: string;
    trend: string;
}
// @ts-ignore
    window.initACTIarBlock = function ($, blockId, config, schoolResponse, networkResponse, districtResponse, bubbleConfigs, notUseDefaultTooltip) {
    const headKey = 'ACT';
    // console.log('initIarBlock', blockId )
    const defaultChartsSettingsStore = createChartFilterStore<ChartsSettings>({
        demographic: "",
        trend: ""
    });
        const chartInstances: Record<string, any> = {};
        // this is the position used to select chart / table to keep it consistent (1=chart, 2=table). hacky until rewrite
        let viewTypePosition = "1";
        let isFirstTrendLoad = true;
    function initSelectedCharts(filters: ChartsSettings) {
        const trends = [
            { id: `${headKey}-math-trend_${filters.trend}_All Students_ALL`, category: 'ALL', group: 'All Students' },
            { id: `${headKey}-math-trend_${filters.trend}_Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Economic Disadvantage' },
            { id: `${headKey}-math-trend_${filters.trend}_Non-Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Non-Economic Disadvantage' },
            { id: `${headKey}-math-trend_${filters.trend}_English Learner_English Learner Status`, category: 'English Learner Status', group: 'English Learner' },
            { id: `${headKey}-math-trend_${filters.trend}_Non-English Learner_English Learner Status`, category: 'English Learner Status', group: 'Non-English Learner' },
            { id: `${headKey}-math-trend_${filters.trend}_Female_Gender`, category: 'Gender', group: 'Female' },
            { id: `${headKey}-math-trend_${filters.trend}_Male_Gender`, category: 'Gender', group: 'Male' },
            { id: `${headKey}-math-trend_${filters.trend}_Non-Binary_Gender`, category: 'Gender', group: 'Non-Binary' },
            { id: `${headKey}-math-trend_${filters.trend}_IEP_IEP Status`, category: 'IEP Status', group: 'IEP' },
            { id: `${headKey}-math-trend_${filters.trend}_Non-IEP_IEP Status`, category: 'IEP Status', group: 'Non-IEP' },
            { id: `${headKey}-math-trend_${filters.trend}_Asian_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian' },
            { id: `${headKey}-math-trend_${filters.trend}_Asian/Pacific Islander (Retired Category)_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian/Pacific Islander (Retired Category)' },
            { id: `${headKey}-math-trend_${filters.trend}_Black/African American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Black/African American' },
            { id: `${headKey}-math-trend_${filters.trend}_Hawaiian/Pacific Islander_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Hawaiian/Pacific Islander' },
            { id: `${headKey}-math-trend_${filters.trend}_Latinx_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Latinx' },
            { id: `${headKey}-math-trend_${filters.trend}_Multiracial_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Multiracial' },
            { id: `${headKey}-math-trend_${filters.trend}_Native American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Native American' },
            { id: `${headKey}-math-trend_${filters.trend}_Not Listed_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Not Listed' },
            { id: `${headKey}-math-trend_${filters.trend}_White_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'White' },
            { id: `${headKey}-math-trend_${filters.trend}_Non-Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Non-Temporary Living Situation' },
            { id: `${headKey}-math-trend_${filters.trend}_Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Temporary Living Situation' },
        ];
        
        const filteredTrens = trends.filter(i => i.category === filters.demographic);
        const scopedIdFn = (id: string) => `${blockId}-${id}`;
        if (filters.trend) {
            getGradeCharts(filters.trend);
        }
        for (let trend of filteredTrens) {
            const fullId = scopedIdFn(trend.id);
            const canvas = document.getElementById(fullId) as HTMLCanvasElement;

            if (canvas) {
                if (chartInstances[fullId]) {
                    chartInstances[fullId].destroy();
                }

                chartInstances[fullId] = new Chart(
                    canvas,
                    //@ts-ignore
                    getCategoryTrendConfig(filters.trend, trend.category, trend.group)
                );
            }
        }
    }

    //const snapshotChartSubscription = metricChartSelectorSubscription(`${blockId}-iar-math-demographics`);
    const demographicsChartSubscription = metricChartSelectorSubscription(`${blockId}-ACT-math-demographics`);
    const trendChartSubscription = metricChartSelectorSubscription(`${blockId}-ACT-math-trend-select`);

    // Subscribe to changes
    demographicsChartSubscription.subscribe(value => {
        defaultChartsSettingsStore.update(prev => ({
            ...prev,
            demographic: value
        }));
    })
    trendChartSubscription.subscribe(value => {
        defaultChartsSettingsStore.update(prev => ({
            ...prev,
            trend: value
        }));
    })

    window.addEventListener("beforeunload", (event) => {
        demographicsChartSubscription.unsubscribe();
        trendChartSubscription.unsubscribe();
        unsubscribeDefaultSettings();
    });
    function getTrendLabels() {
        return districtResponse.SchoolYears.map(y => y.SchoolYear);
    }


    const getTooltip = (key) => {
        return bubbleConfigs[key] ?? '';
    }
    const getCategoryMappedTooltip = (category) => {
        const mappedField = mappedBubbleConfigFieldKeys[category];
        return getTooltip(mappedField);
    }
    // @TODO create new keys for these
    const mappedBubbleConfigFieldKeys =
    {
        "ALL": "allstudents",
        "Economic Disadvantage": "economicdisadvantage",
        "English Learner Status": "englishlearner",
        "Gender": "gender",
        "Grade Level": "grade",
        "IEP Status": "iep",
        "Race/Ethnicity": "raceethnicity",
        "Temporary Living Situation Status": "stls",
    }

    const scopedId = (id: string) => `${blockId}-${id}`;
    const parentScope = '.' + scopedId('metric-block');


    function tempShaper(response) {
        const data = [];
        for (let year of response.SchoolYears) {
            data.push(...year.Categories.map(category => ({
               
                ...upperizeStringify(category),
                CATEGORY_DESCRIPTION: category.CategoryDescription,
                SCHOOL_YEAR: year.SchoolYear,

                //LESSTHAN10: category.Lessthan10 == "" ? "0" : category.Lessthan10,
                LESSTHAN10: category.Lessthan10 == "" ? 0 : 1,
                //NODATA: category.NoData == "" ? "0" : category.NoData,
                NODATA: category.NoData == "" ? 0 : 1,

                NETWORK: response.Network,
                "BELOW_PERCENT": category.BelowprofPercent,
                "BELOW_NUMERATOR": category.BelowprofNumerator,
                "APPROACHING_PERCENT": category.ApprprofPercent,
                "APPROACHING_NUMERATOR": category.ApprprofNumerator,
                "PROFICIENT_PERCENT": category.ProficientPercent,
                "PROFICIENT_NUMERATOR": category.ProficientNumerator,
                "ABOVEPROF_NUMERATOR": category.AboveprofNumerator,
                "ABOVEPROF_PERCENT": category.AboveprofPercent,

                METRIC_TITLE: response.MetricTitle

            })))
        }
        return data;
    }
    const iarSchoolData = tempShaper(fillMissingData(schoolResponse, IarMetricSampleRow));
    const networkIARData = tempShaper(fillMissingData(networkResponse, IarMetricSampleRow));
    const districtIARData = tempShaper(fillMissingData(districtResponse, IarMetricSampleRow));

    let network = config.network
    let schoolName = config.schoolName;
    //let chartMetric = config.metricName;
    let currentYear = '2024-2025';
    const trendLabels = districtResponse.SchoolYears.map(y => y.SchoolYear);
    let selectedCategory = "ALL";
    const yearSort = (a, b) => (trendLabels.indexOf(a.SCHOOL_YEAR) - trendLabels.indexOf(b.SCHOOL_YEAR));

    // this is a hack to resize for when there's fewer than the typical 3 years
    // it should be done in HTML with classes, but doing it here will make it easier to refactor later
    if (trendLabels.length < 3) {
        // 85 is about the height of just the bar area for one bar, 115 is about what's needed for the pabel
        const newHeight = (115+(85 * Math.max(trendLabels.length))).toFixed(0);
        const styleNode = document.createElement('style');
        const scopeKey = scopedId(`metric-block`);
        const referenceNode = document.querySelector('.'+scopeKey);
        styleNode.innerHTML = `.${scopeKey} .trend-container {height: ${newHeight}px}`;
        if (referenceNode) {
            referenceNode.prepend(styleNode);
        }
    }

    let snapshotLabels = {
        "ALL": getLabels("ALL"),
        "Race/Ethnicity": getLabels("Race/Ethnicity"),
        "Economic Disadvantage": getLabels("Economic Disadvantage"),
        "English Learner Status": getLabels("English Learner Status"),
        "Gender": getLabels("Gender"),
        "Grade Level": getGradeLabels("Grade Level"),
        "IEP Status": getLabels("IEP Status"),
        "Temporary Living Situation Status": getLabels("Temporary Living Situation Status")
    }



    const snapshotTooltipConfig = {
        enabled: true, titleFont: tooltipTitleFont, callbacks: {
            title: function (tooltipItem) {
                return ''
            }, label: function (tooltipItem) {
                let idArray = tooltipItem.chart.canvas.id.replace(scopedId(''), '').split("_");
                let desc = idArray.pop();
                let cat = idArray.pop();
                let raw = getSnapshotRaw(desc, cat);
                let data = raw[tooltipItem.dataIndex];
                let percent;
                let total;
                switch (tooltipItem.datasetIndex) {
                    case 0:
                        total = "BELOW_NUMERATOR";
                        percent = "BELOW_PERCENT";
                        break;
                    case 1:
                        total = "APPROACHING_NUMERATOR";
                        percent = "APPROACHING_PERCENT";
                        break;
                    case 2:
                        total = "PROFICIENT_NUMERATOR";
                        percent = "PROFICIENT_PERCENT";
                        break;
                    case 3:
                        total = "ABOVEPROF_NUMERATOR";
                        percent = "ABOVEPROF_PERCENT";
                        break;
                }
                let line1 = [`${tooltipItem.label}- % ${tooltipItem.dataset.label}: ${data[percent]}%`];
                let line2 = `Total ${tooltipItem.dataset.label}: ${Number(data[total]).toLocaleString()}`;
                let line3 = `Total Students: ${Number(data.DENOMINATOR).toLocaleString()}`;
                line1.push(line2, line3);
                return line1;
            }
        }
    };

    const trendTooltipConfig = {
        enabled: true, titleFont: tooltipTitleFont, callbacks: {
            title: function (tooltipItem) {
                return ''
            }, label: function (tooltipItem) {
                let idArray = tooltipItem.chart.canvas.id.replace(scopedId(''), '').split("_");
                let desc = idArray.pop();
                let cat = idArray.pop();
                let dataset = idArray.pop();
                let raw = getTrendRaw(dataset, desc, cat);
                let data = raw[tooltipItem.dataIndex];
                let percent;
                let total;
                switch (tooltipItem.datasetIndex) {
                    case 0:
                        total = "BELOW_NUMERATOR";
                        percent = "BELOW_PERCENT";
                        break;
                    case 1:
                        total = "APPROACHING_NUMERATOR";
                        percent = "APPROACHING_PERCENT";
                        break;
                    case 2:
                        total = "PROFICIENT_NUMERATOR";
                        percent = "PROFICIENT_PERCENT";
                        break;
                    case 3:
                        total = "ABOVEPROF_NUMERATOR";
                        percent = "ABOVEPROF_PERCENT";
                        break;
                }
                let line1 = [`${tooltipItem.label}- % ${tooltipItem.dataset.label}: ${data[percent]}%`];
                let line2 = `Total ${tooltipItem.dataset.label}: ${Number(data[total]).toLocaleString()}`;
                let line3 = `Total Students: ${Number(data.DENOMINATOR).toLocaleString()}`;
                line1.push(line2, line3);
                return line1;
            }
        }
    };


    const snapshotDatalabelConfig = {
        display: false,
        color: '#000000',
        font: datalabelFont,
    };

    function trendDatalabelConfig() {
        return {
            display: false,
            color: '#000000',
            font: datalabelFont,
        }
    };

    // Draws percent labels inside each bar segment using direct canvas rendering.
    // chartjs-plugin-datalabels mispositions labels on horizontal bars in Chart.js v4,
    // so we use meta.x and meta.base (the segment's pixel extents) directly.
    const iarTopLabels = {
        id: 'iarTopLabels',
        afterDatasetsDraw(chart: any, args: any, options: any) {
            const { ctx } = chart;
            const isWide = chart.width > 505;
            ctx.font = isWide
                ? "400 12px \"Roboto\", Roboto, Arial, sans-serif"
                : "400 9px \"Roboto\", Roboto, Arial, sans-serif";
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            chart.data.datasets.forEach((dataset: any, index: number) => {
                if (!chart.isDatasetVisible(index)) return;
                const centerLabels: (string | null)[] = dataset._centerLabels ?? [];
                centerLabels.forEach((labelText: string | null, i: number) => {
                    if (!labelText) return;
                    const meta = chart.getDatasetMeta(index).data[i] as any;
                    const barWidth = Math.abs(meta.x - meta.base);
                    if (!(barWidth > 20)) return;
                    const xCenter = (meta.x + meta.base) / 2;
                    const bgColor = (Array.isArray(dataset.backgroundColor)
                        ? dataset.backgroundColor[i]
                        : dataset.backgroundColor) as string;
                    ctx.save();
                    ctx.fillStyle = getContrastColor(bgColor ?? '#ffffff');
                    ctx.fillText(labelText, xCenter, meta.y);
                    ctx.restore();
                });
            });
        }
    };

    $(".ACT-math-school-trends, .ACT-math-district-trends, .ACT-math-network-trends").hide().removeClass('hidden');

    function getLabels(type) {
        return Array.from(new Set(iarSchoolData.filter((value) => value.CATEGORY === type)
            .map((item) => item.CATEGORY_DESCRIPTION))).sort()
    }

    function getGradeLabels(type) {
        let gradeOrder = ["PE", "PK", "PE/PK", "K", "KG", "1", "01", "2", "02", "3", "03", "4", "04", "5", "05", "6", "06", "7", "07", "8", "08", "9", "09", "10", "11", "12"];
        return Array.from(new Set(iarSchoolData.filter((item) =>
            item.CATEGORY === type)
            .map((item) => item.CATEGORY_DESCRIPTION))).sort((a, b) => gradeOrder.indexOf(a) - gradeOrder.indexOf(b));
    }

    createSnapshot();
    setTrendChart();
    //setSnapshotHeight();

    let trendSelect = document.getElementById(scopedId(`${headKey}-math-trend-select`));
    trendSelect.addEventListener("change", showTrends);

    $('#' + scopedId(`${headKey}-math-trend-select`)).bind('click', function () {
        let value = $(this).find('option:selected').val();
        let vals = ["school", "network", "district"];
        // @ts-ignore
        if (vals.includes(value)) {
            displayTrend(value);
        }
    });

    $('#' + scopedId(`${headKey}-math-show-snapshot`)).on("click", showSnapshot);

    function getSnapshotRaw(category, label) {
        let schoolArr = iarSchoolData.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label).filter((value) => value.SCHOOL_YEAR === currentYear);
        let networkArr = networkIARData.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label && snapshotLabels[category].includes(value.CATEGORY_DESCRIPTION)).filter((value) => value.SCHOOL_YEAR === currentYear);
        let districtArr = districtIARData.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label && snapshotLabels[category].includes(value.CATEGORY_DESCRIPTION)).filter((value) => value.SCHOOL_YEAR === currentYear);
        const ret = [...schoolArr, ...networkArr, ...districtArr];
        return ret;
    }

    function getTrendRaw(data, category, label) {
        const iarSchoolDataL = tempShaper(fillMissingData(schoolResponse, IarMetricSampleRow));
        const networkIARDataL = tempShaper(fillMissingData(networkResponse, IarMetricSampleRow));
        const districtIARDataL = tempShaper(fillMissingData(districtResponse, IarMetricSampleRow));
        let dataset;
        switch (data) {
            case "school":
                dataset = iarSchoolDataL;
                break;
            case "network":
                dataset = networkIARDataL;
                break;
            case "district":
                dataset = districtIARDataL;
                break;
        }

        const ret = dataset.filter((value) => value.CATEGORY === category && value.CATEGORY_DESCRIPTION === label).sort(yearSort);
        return ret;
    }

    function getNotApproachingData(category, label) {
        let array = [];
        let approachingValues = getApproachingData(category, label);
        let rawData = getSnapshotRaw(category, label);
        rawData.forEach((value, index) => {
            let approaching = approachingValues[index][0];
            //if (value.PARTIALLYMET_PERCENT !== "NULL") {
            if (value.APPROACHING_PERCENT !== null) {
                let notApproaching = parseFloat(value.APPROACHING_PERCENT);
                let start = 0 - notApproaching;
                let end = 0;
                array.push([start, end]);
            } else {
                array.push([approaching, approaching])
            }
        })
        return array;
    }

    function getApproachingData(category, label) {
        let array = [];
        let rawData = getSnapshotRaw(category, label);

        rawData.forEach((value) => {
            if (value.PROFICIENT_PERCENT) {
                array.push([0 + parseFloat(value.PROFICIENT_PERCENT)])
            } else {
                array.push([0, 0])
            }
        })
        return array;
    }

    

    function getMeetingData(category, label) {
        let array = [];
        let rawData = getSnapshotRaw(category, label);
        rawData.forEach((value) => {
            const proficientPercent = value.PROFICIENT_PERCENT ? parseFloat(value.PROFICIENT_PERCENT) : 0;

            array.push([proficientPercent, proficientPercent + parseFloat(value.ABOVEPROF_PERCENT)])
        })
        return array;
    }


    function getBelowPercentSnapshotData(category, label) {
        let array = [];
        let notApproachingValues = getNotApproachingData(category, label);
        let rawData = getSnapshotRaw(category, label);

        rawData.forEach((value, index) => {
            let notApproaching = notApproachingValues[index][0];
            if (value.LESSTHAN10 == 1 || value.NODATA == 1) {
                // this is a horrific hack to get "No Data" messages to show on the chart for now.
                // it's paired with the code in the display callback of the chart
                array.push([NaN, NaN])
                return true;
            }
            if (value.BELOW_PERCENT !== null) {
                let notMeeting = parseFloat(value.BELOW_PERCENT);
                let start = 0 - (Math.abs(notApproaching) + notMeeting);
                let end = 0 + notApproaching;
                array.push([start, end]);
            } else {
                array.push([notApproaching, notApproaching])
            }
        })
        return array;
    }

    
    function getApproachingTrendData(data, category, label) {
        let array = [];
        let rawData = getTrendRaw(data, category, label);
        rawData.forEach((value) => {
            if (!isNaN(parseFloat(value.APPROACHING_PERCENT))) {
                array.push([0 - parseFloat(value.APPROACHING_PERCENT), 0])
            } else {
                array.push([value.APPROACHING_PERCENT, 0])
            }
        })
        return array
    }

    function getProficientTrendData(data, category, label) {
        let array = [];
        let rawData = getTrendRaw(data, category, label);
        rawData.forEach((value) => {
            array.push(parseFloat(value.PROFICIENT_PERCENT))
        })
        return array;
    }

    function getExceedingTrendData(data, category, label) {
        let array = [];
        let rawData = getTrendRaw(data, category, label);
        let meetingValues = getProficientTrendData(data, category, label);
        rawData.forEach((value, index) => {
            let meeting;
            let exceeding
            if (!isNaN(parseFloat(meetingValues[index]))) {
                meeting = meetingValues[index];
            } else {
                meeting = 0;
            }
            if (!isNaN(parseFloat(value.ABOVEPROF_PERCENT))) {
                exceeding = parseFloat(value.ABOVEPROF_PERCENT);
            } else {
                exceeding = meeting;
            }
            let start = meeting;
            let end = meeting + exceeding;
            array.push([start, end]);
        })
        return array;
    }

    function getBelowTrendData(data, category, label) {
        let array = [];
        let approachingValues = getApproachingTrendData(data, category, label);
        let rawData = getTrendRaw(data, category, label);
        rawData.forEach((value, index) => {
            let approaching;
            let below;
            if (value.LESSTHAN10 == 1 || value.NODATA == 1) {
                // this is a horrific hack to get "No Data" messages to show on the chart for now.
                // it's paired with the code in the display callback of the chart
                array.push([NaN, NaN])
                return true;
            }

            if (!isNaN(parseFloat(approachingValues[index][0]))) {
                approaching = approachingValues[index][0];
            } else {
                approaching = 0;
            }
            if (!isNaN(parseFloat(value.BELOW_PERCENT))) {
                below = parseFloat(value.BELOW_PERCENT);
            } else {
                below = 0;
            }
            let start = 0 - (Math.abs(approaching) + below);
            let end = approaching;
            array.push([start, end]);
        })
        return array;
    }

    function getTrendData(data, category, label) {
        const rawRows = getTrendRaw(data, category, label);
        const trendCenterLabels = (field: string) => rawRows.map(row =>
            (row.LESSTHAN10 == 1 || row.NODATA == 1) ? null
                : row[field] != null ? String(row[field]) : null
        );

        return {
            labels: getTrendLabels(),
            datasets: [
                {
                    label: 'Below',
                    data: getBelowTrendData(data, category, label),
                    backgroundColor: '#FFA110',
                    _centerLabels: trendCenterLabels('BELOW_PERCENT'),
                }
                , {
                    label: 'Approaching',
                    data: getApproachingTrendData(data, category, label),
                    backgroundColor: '#2D8494',
                    _centerLabels: trendCenterLabels('APPROACHING_PERCENT'),
                    datalabels: {
                        color: 'white'
                    }
                }, {
                    label: 'Proficient',
                    data: getProficientTrendData(data, category, label),
                    backgroundColor: '#8B2BA1',
                    _centerLabels: trendCenterLabels('PROFICIENT_PERCENT'),
                    datalabels: {
                        color: 'white'
                    }
                }, {
                    label: 'Exceeds',
                    data: getExceedingTrendData(data, category, label),
                    backgroundColor: '#061A53',
                    _centerLabels: trendCenterLabels('ABOVEPROF_PERCENT'),
                    datalabels: {
                        color: 'white'
                    }
                },
            ]
        }
    }

    function getDropoutSnapshotData(category, label) {
        const rawRows = getSnapshotRaw(category, label);
        const snapCenterLabels = (field: string) => rawRows.map(row =>
            (row.LESSTHAN10 == 1 || row.NODATA == 1) ? null
                : row[field] != null ? String(row[field]) : null
        );

        const ret = {
            labels: ['School', 'Network', 'District'],
            datasets: [
                {
                    label: 'Below',
                    data: getBelowPercentSnapshotData(category, label),
                    backgroundColor: '#FFA110',
                    _centerLabels: snapCenterLabels('BELOW_PERCENT'),
                },
                {
                    label: 'Approaching',
                    data: getNotApproachingData(category, label),
                    backgroundColor: '#2D8494',
                    _centerLabels: snapCenterLabels('APPROACHING_PERCENT'),
                    datalabels: {
                        color: 'white'
                    }
                }, {
                    label: 'Proficient',
                    data: getApproachingData(category, label),
                    backgroundColor: '#8B2BA1',
                    _centerLabels: snapCenterLabels('PROFICIENT_PERCENT'),
                    datalabels: {
                        color: 'white'
                    }
                },
                {
                    label: 'Exceeds',
                    data: getMeetingData(category, label),
                    backgroundColor: '#061A53',
                    _centerLabels: snapCenterLabels('ABOVEPROF_PERCENT'),
                    datalabels: {
                        color: 'white'
                    }
                }]
        }
        return ret;
    }

    function getAllSnapshotConfig(category, label) {
        return {
            type: 'bar',
            plugins: [legendPad, ChartDataLabels, iarTopLabels, legendOffsetPlugin, htmlLegendPlugin],
            data: getDropoutSnapshotData(category, label),
            options: {
                layout: {
                    padding: {
                        right: 50
                    }
                },
                indexAxis: 'y',
                maintainAspectRatio: false,
                onResize: onResize,
                scales: {
                    x: {
                        max: 100,
                        min: -100,
                        grid: {
                            display: false
                        },
                        title: {
                            display: true,
                            text: "% of Students",
                            color: "black"
                        },
                    }, y: {
                        stacked: true,
                        grid: {
                            offset: false,
                            display: false
                        }, ticks: {
                            color: "black"
                        }
                    }
                }, plugins: {
                    datalabels: snapshotDatalabelConfig,
                    tooltip: snapshotTooltipConfig,
                    legend: { display: false },
                    htmlLegend: {
                        containerID: `${blockId}-${label}-actIar-snapshot`
                    },
                }
            }
        }
    }
        function getCategoryTrendConfig(data, category, label) {
        return {
            type: 'bar',
            plugins: [ChartDataLabels, iarTopLabels, legendOffsetPlugin, legendPad, htmlLegendPlugin],
            data: getTrendData(data, category, label),
            options: {
                layout: {
                    padding: {
                        right: 50
                    }
                },

                onResize: onResize,
                maintainAspectRatio: false,
                indexAxis: 'y',
                scales: {
                    x: {
                        grid: {
                            display: true,
                            color: '#DDE0E7'
                        },
                        border: {
                            dash: [5, 5]
                        },
                        max: 100,
                        min: -100,
                        title: {
                            display: true,
                            text: "% of Students",
                            color: "black"
                        }
                    }, y: {
                        stacked: true,
                        grid: {
                            offset: false,
                            display: false
                        }, ticks: {
                            color: "black"
                        }
                    }
                }, plugins: {
                    datalabels: trendDatalabelConfig(),
                    tooltip: trendTooltipConfig,
                    legend: { display: false },
                    htmlLegend: {
                        containerID: `${blockId}-${data}-${label}-actIar`
                    },
                    legendOffsetPlugin: {
                        offsetX: 3, 
                        offsetY: 0
                    }
                }
            }
        }
    }

    let absenceSelect = document.getElementById(scopedId(`${headKey}-math-demographics`));
    absenceSelect.addEventListener("change", changeDropoutDemographic);

   /* function setSnapshotHeight() {
        let height;
        let length = snapshotLabels[selectedCategory].length;
        const viewportWidth = (window.innerWidth || document.documentElement.clientWidth || 0);

        if (selectedCategory === "Race/Ethnicity" || "Grade") {
            height = length * 450;
        } else {
            height = length * 435;
        }
        
        let snapshotHeight = document.getElementById(scopedId(`${headKey}-math-snapshot-height`));
        snapshotHeight.style.height = height.toString() + "px";
    }*/

        function setSnapshotHeight() {
            // Find snapshot containers for the currently selected category and only keep those that are visible
            const allSnapshotContainers = Array.from(document.querySelectorAll(`${parentScope} .snapshot-container`)) as HTMLElement[];

            // Keep only containers that contain a canvas for the selectedCategory.
            // Canvas ids are created as: scopedId(`snapshot_${ headKey }-math_${label}_${category}`)
            const snapshotContainersForCategory = allSnapshotContainers.filter(sc => {
                const canvas = sc.querySelector('canvas') as HTMLCanvasElement | null;
                if (!canvas || !canvas.id) return false;
                // match the category token in the canvas id to ensure we're only working with snapshots for the selectedCategory
                return canvas.id.includes(`_${selectedCategory}`);
            });

            // From those, keep only the ones that are currently displayed (computed display === 'block')
            const visibleChartContainers = snapshotContainersForCategory.filter(sc => {
                try {
                    const style = window.getComputedStyle(sc);
                    return style && style.display === 'block';
                } catch {
                    return false;
                }
            });

            // Fallback label count when no visible containers found
            const labels = snapshotLabels[selectedCategory] || [];
            const length = Math.max(labels.length, 1);

            const viewportWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
            const marginTotal = viewportWidth > 682 ? (32 + 24 + 25) : (20 + 20 + 25);

            let totalHeightSum = 0;

            try {
                if (visibleChartContainers.length === 0) {
                    // No visible chart containers — use a conservative fallback based on expected chart height
                    const fallbackChartHeight = 320;
                    const perItemHeight = Math.max(Math.round(fallbackChartHeight + marginTotal), 300);
                    const computedHeight = Math.max(Math.round(length * perItemHeight), 300);
                    const snapshotHeightElem = document.getElementById(scopedId(`${headKey}-math-snapshot-height`));
                    if (snapshotHeightElem instanceof HTMLElement) {
                        snapshotHeightElem.style.height = computedHeight + "px";
                        snapshotHeightElem.style.minHeight = computedHeight + "px";
                    } else {
                        // fallback: apply to snapshot-container elements
                        const containers = Array.from(document.querySelectorAll(`${parentScope} .snapshot-container`)) as HTMLElement[];
                        containers.forEach(c => {
                            try {
                                c.style.height = computedHeight + "px";
                                c.style.minHeight = computedHeight + "px";
                            } catch { /* defensive */ }
                        });
                    }
                    //console.log('setSnapshotHeight (fallback):', computedHeight, 'viewportWidth:', viewportWidth, 'items:', length);
                } else {
                    // Measure each visible chart-container and sum heights
                    visibleChartContainers.forEach(cc => {
                        let titleHeight = 0;
                        let legendHeight = 0;
                        let chartHeight = 320; // default fallback

                        // Prefer measuring the title <p> inside the containing snapshot-container if available
                        const snapshotParent = cc.closest('.snapshot-container') as HTMLElement | null;
                        if (snapshotParent) {
                            const p = snapshotParent.querySelector('p');
                            if (p instanceof HTMLElement) {
                                titleHeight = Math.round(p.getBoundingClientRect().height);
                            }
                            const legend = snapshotParent.querySelector('.html-legend-plugin__container') as HTMLElement | null;
                            if (legend instanceof HTMLElement) {
                                legendHeight = Math.round(legend.getBoundingClientRect().height);
                            }
                            const canvas = snapshotParent.querySelector('canvas') as HTMLCanvasElement | null;
                            if (canvas instanceof HTMLCanvasElement) {
                                const measured = Math.round(canvas.getBoundingClientRect().height);
                                if (measured > 0) chartHeight = measured;
                            }
                        } else {
                            // If no snapshot parent, try to measure within the chart-container itself
                            const p = cc.querySelector('p') as HTMLElement | null;
                            if (p instanceof HTMLElement) titleHeight = Math.round(p.getBoundingClientRect().height);
                            const legend = cc.querySelector('.html-legend-plugin__container') as HTMLElement | null;
                            if (legend instanceof HTMLElement) legendHeight = Math.round(legend.getBoundingClientRect().height);
                            const canvas = cc.querySelector('canvas') as HTMLCanvasElement | null;
                            if (canvas instanceof HTMLCanvasElement) {
                                const measured = Math.round(canvas.getBoundingClientRect().height);
                                if (measured > 0) chartHeight = measured;
                            }
                        }

                        const perContainerHeight = Math.max(Math.round(chartHeight + titleHeight + legendHeight + marginTotal), 300);

                        // If snapshotParent exists, apply height to it; otherwise apply to chart-container
                        try {
                            if (snapshotParent instanceof HTMLElement) {
                                snapshotParent.style.height = perContainerHeight + "px";
                                snapshotParent.style.minHeight = perContainerHeight + "px";
                            } else {
                                cc.style.height = perContainerHeight + "px";
                                cc.style.minHeight = perContainerHeight + "px";
                            }
                        } catch (applyErr) {
                            console.warn('setSnapshotHeight: failed to apply per-container height', applyErr);
                        }

                        totalHeightSum += perContainerHeight;
                    });

                    // Apply summed height to explicit snapshot wrapper if present
                    const snapshotHeightElem = document.getElementById(scopedId(`${headKey}-math-snapshot-height`));
                    if (snapshotHeightElem instanceof HTMLElement) {
                        try {
                            snapshotHeightElem.style.height = Math.max(totalHeightSum, 300) + "px";
                            snapshotHeightElem.style.minHeight = Math.max(totalHeightSum, 300) + "px";
                        } catch (e) {
                            console.warn('setSnapshotHeight: failed to apply height to snapshot wrapper', e);
                        }
                    }

                   // console.log('setSnapshotHeight: computed total from visible .chart-container:', totalHeightSum, 'viewportWidth:', viewportWidth, 'visibleContainers:', visibleChartContainers.length);
                }
            } catch (e) {
                console.warn('setSnapshotHeight: unexpected error', e);
            }

            // Resize chart instances so canvases redraw to new sizes
            try {
                Object.values(chartInstances).forEach((inst: any) => {
                    try {
                        if (inst && typeof inst.resize === 'function') inst.resize();
                    } catch { /* ignore individual errors */ }
                });
            } catch (e) {
                console.warn('setSnapshotHeight: chart resize failed', e);
            }
        }

    function changeDropoutDemographic(event) {
        let selected = event.target.value;

        selectedCategory = selected;
        setTrendChart();
        let $retired = $(`#${headKey}-math-retired`);
        setSnapshotHeight();
        switch (selected) {
            case "Race/Ethnicity":
                $retired.removeClass("hidden");
                break;
            default:
                $retired.addClass("hidden");
                break;
        }

    }

    function createSnapshotTables() {
        let rows = [schoolName, "Network", "District"];
        let columns = ["BELOW", "APPROACHING", "PROFICIENT", "ABOVEPROF"]
        let categories = Object.keys(snapshotLabels);
        categories.forEach((category) => {
            let type;
            if (category === "Race/Ethnicity") {
                type = "race";
            } else {
                type = category.toLowerCase().replace(/ .*/, '');
            }

            let labels = snapshotLabels[category];
            let parent = document.getElementById(scopedId(`${headKey}-math-${type}-tables`));

            labels.forEach((label) => {
                let data = getSnapshotRaw(category, label);
                let categoryChartTableDiv = document.createElement('div');
                categoryChartTableDiv.classList.add('snapshot-chart');
                let header = document.createElement('p');
                let key = `${category} - ${label}`;
                const tipContent = getCategoryMappedTooltip(category);
                header.innerHTML = `<p style="text-align: center;"><strong>
                <span class="school-name">${config.schoolName} </span>- ${config.metricName} - <span>${bubbleConfigs[mappedBubbleConfigFieldKeys[`${category} - ${label}`]]?.Title ?? label}</span>&nbsp;<span data-toggle="school-profile-tooltip"
                                                                                 class="school-info-bubble fa fa-info-circle"
                                                                                 data-html="true"
                                                                                 data-tooltip-content="${tipContent}" aria-label="More Info: Click here"></span></strong>
                        </p>`;
                categoryChartTableDiv.appendChild(header);
                let categoryChartBox = document.createElement('div');
                categoryChartBox.classList.add("table-scrolling-wrapper");
                let categoryTable = document.createElement('table');
                categoryTable.classList.add('chart-table');
                let categoryThead = categoryTable.createTHead();
                categoryThead.insertRow(0);
                categoryThead.rows[0].insertCell(0).classList.add('light-cyan');
                categoryThead.rows[0].insertCell(1).outerHTML = `<th>Below</th>`;
                categoryThead.rows[0].insertCell(2).outerHTML = `<th>Approaching</th>`;
                categoryThead.rows[0].insertCell(3).outerHTML = `<th>Proficient</th>`;
                categoryThead.rows[0].insertCell(4).outerHTML = `<th>Exceeds</th>`;

                const categoryTableBody = categoryTable.createTBody();
                data.forEach((value, index) => {
                    categoryTableBody.insertRow(index);
                    categoryTableBody.rows[index].insertCell(0).outerHTML = `<th scope='row'>${rows[index]}</th>`;
                    columns.forEach((column, i) => {
                        if (value.LESSTHAN10 == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "Fewer than 10 students";
                        } else if (value.NODATA == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "No data";
                        } else {
                            const val_PERCENT = value[columns[i] + '_PERCENT'] ? value[columns[i] + '_PERCENT'].toLocaleString() : '0';
                            const val_NUMERATOR = value[columns[i] + '_NUMERATOR'] ? value[columns[i] + '_NUMERATOR'].toLocaleString() : '';

                            categoryTableBody.rows[index].insertCell(i + 1).innerText = `${val_PERCENT}%\n${val_NUMERATOR}`;
                        }
                    })
                })
                categoryChartBox.appendChild(categoryTable);
                categoryChartTableDiv.appendChild(categoryChartBox)
                parent.appendChild(categoryChartTableDiv)

                header.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                    infoBubble(el);
                });

            })

        })
    }

    function createTrendTables(data) {
        for (const category in snapshotLabels) {
            const columns = ["BELOW", "APPROACHING", "PROFICIENT", "ABOVEPROF"];
            let type;
            if (category === "Race/Ethnicity") {
                type = "race";
            } else {
                type = category.toLowerCase().replace(/ .*/, '');
            }

            // Use a copy of the labels so we don't mutate the original snapshotLabels array.
            let labels = [...snapshotLabels[category]];
            if (category === "Grade Level") {
                labels.reverse();
            }

            const parent = document.getElementById(scopedId(`${headKey}-math-${type}-tables-${data}-trend`));
            if (!parent) continue;

            // Clear existing content to prevent duplicated tables when this function is called multiple times.
            parent.innerHTML = '';

            labels.forEach((label) => {
                let dataset = getTrendRaw(data, category, label);
                let categoryChartTableDiv = document.createElement('div');
                categoryChartTableDiv.classList.add('snapshot-chart');
                let header = document.createElement('p');
                let title;
                switch (data) {
                    case "school":
                        title = schoolName;
                        break;
                    case "network":
                        title = `Network`;
                        break;
                    case "district":
                        title = "District";
                        break;
                }
                const tipContent = getCategoryMappedTooltip(category);
                header.innerHTML = `<p style="text-align: center;"><strong><span class="school-name">${title} </span>- ${config.metricName} - <span>${label}</span>&nbsp;<span data-toggle="school-profile-tooltip"
                                                                                             class="school-info-bubble fa fa-info-circle"
                                                                                             data-html="true"
                                                                                             data-tooltip-content="${tipContent}" aria-label="More Info: Click here"></span></strong>
                            </p>`;
                categoryChartTableDiv.appendChild(header);
                let categoryChartBox = document.createElement('div');
                categoryChartBox.classList.add("table-scrolling-wrapper");
                let categoryTable = document.createElement('table');
                categoryTable.classList.add('chart-table');
                let categoryThead = categoryTable.createTHead();
                categoryThead.insertRow(0);
                categoryThead.rows[0].insertCell(0).classList.add('light-cyan');
                categoryThead.rows[0].insertCell(1).outerHTML = `<th>Below</th>`;
                categoryThead.rows[0].insertCell(2).outerHTML = `<th>Approaching</th>`;
                categoryThead.rows[0].insertCell(3).outerHTML = `<th>Proficient</th>`;
                categoryThead.rows[0].insertCell(4).outerHTML = `<th>Exceeds</th>`;
                const categoryTableBody = categoryTable.createTBody();
                dataset.forEach((value, index) => {
                    categoryTableBody.insertRow(index);
                    categoryTableBody.rows[index].insertCell(0).outerHTML = `<th scope='row'>${trendLabels[index]}</th>`;
                    columns.forEach((column, i) => {
                        if (value.LESSTHAN10 == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "Fewer than 10 students";
                        } else if (value.NODATA == 1) {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = "No data";
                        } else {
                            categoryTableBody.rows[index].insertCell(i + 1).innerText = `${value[columns[i] + '_PERCENT'].toLocaleString()}%\n${Number(value[columns[i] + '_NUMERATOR']).toLocaleString()}`;
                        }
                    })
                })
                categoryChartBox.appendChild(categoryTable);
                categoryChartTableDiv.appendChild(categoryChartBox)
                parent.appendChild(categoryChartTableDiv)

                header.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                    infoBubble(el);
                });
            })
        }
    }
    function getGradeCharts(dataset: string) {
        let category = "Grade Level";
        let gradesServed = snapshotLabels["Grade Level"];

        let parent = document.getElementById(scopedId(`${headKey}-math-${dataset}-grade`));

        if (!parent) return;

        parent.innerHTML = '';

        [...gradesServed].reverse().forEach((grade) => {
            let container = document.createElement("div");
            container.classList.add("trend-container");

            let title;
            switch (dataset) {
                case "school":
                    title = config.schoolName;
                    break;
                case "network":
                    title = config.network;
                    break;
                case "district":
                    title = "District";
                    break;
                default:
                    title = config.schoolName;
            }

            const tipContent = getCategoryMappedTooltip(category);
            const canvasId = scopedId(`${headKey}-math-trend_${dataset}_${grade}_Grade Level`);

            container.innerHTML = `
            <p style="text-align: center;">
                <strong>
                    <span class="school-name">${title}</span> - ${config.metricName} - <span>${grade}</span>
                    <span data-toggle="school-profile-tooltip" 
                          class="school-info-bubble fa fa-info-circle" 
                          data-html="true" 
                          data-tooltip-content="${tipContent}" 
                          aria-label="More Info: Click here">
                    </span>
                </strong>
            </p>`;

            let canvasDiv = document.createElement('canvas');
            canvasDiv.setAttribute('id', canvasId);
            container.appendChild(canvasDiv);

            parent.insertAdjacentElement('afterbegin', container);

            container.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                infoBubble(el);
            });

            if (chartInstances[canvasId]) {
                chartInstances[canvasId].destroy();
            }

            chartInstances[canvasId] = new Chart(
                canvasDiv,
                // @ts-ignore
                getCategoryTrendConfig(dataset, category, grade)
            );
        });
    }
    

    function createSnapshot() {
        let categories = Object.keys(snapshotLabels);
        categories.forEach((category) => {
            let type;
            if (category === "Race/Ethnicity") {
                type = "race";
            } else {
                type = category.toLowerCase().replace(/ .*/, '');
            }

            let labels = snapshotLabels[category];
            let parent = document.getElementById(scopedId(`${headKey}-math-${type}-charts`));
            labels.forEach((label) => {
                let container = document.createElement("div");
                container.classList.add("snapshot-container")
                const tipContent = getCategoryMappedTooltip(category);
                container.innerHTML = `<p style="text-align: center;"><strong><span class="school-name">${config.schoolName} </span>- ${config.metricName} - <span>${bubbleConfigs[mappedBubbleConfigFieldKeys[`${category} - ${label}`]]?.Title ?? label}</span>&nbsp;<span data-toggle="school-profile-tooltip"
                                                                                 class="school-info-bubble fa fa-info-circle"
                                                                                 data-html="true"
                                                                                 data-tooltip-content="${tipContent}" aria-label="More Info: Click here"></span></strong>
                        </p>`;

                let canvasDiv = document.createElement('canvas');
                canvasDiv.setAttribute('id', scopedId(`snapshot_${ headKey }-math_${label}_${category}`));
                container.appendChild(canvasDiv);
                parent.appendChild(container);

                container.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
                    infoBubble(el);
                });


                // @ts-ignore
                new Chart(
                    // @ts-ignore
                    document.getElementById(scopedId(`snapshot_${ headKey }-math_${label}_${category}`)),
                    getAllSnapshotConfig(category, label)
                );
            })
        })

        createSnapshotTables();
    }

    function buildTrends() {
        ["school", "network", "district"].forEach((dataset) => {
            createTrends(dataset);
            createTrendTables(dataset);
        })
    }

    function createTrends(dataset) {
        return new Promise((resolve) => {
            const trends = [
                { id: `${headKey}-math-trend_${dataset}_All Students_ALL`, category: 'ALL', group: 'All Students' },
                { id: `${headKey}-math-trend_${dataset}_Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Economic Disadvantage' },
                { id: `${headKey}-math-trend_${dataset}_Non-Economic Disadvantage_Economic Disadvantage`, category: 'Economic Disadvantage', group: 'Non-Economic Disadvantage' },
                { id: `${headKey}-math-trend_${dataset}_English Learner_English Learner Status`, category: 'English Learner Status', group: 'English Learner' },
                { id: `${headKey}-math-trend_${dataset}_Non-English Learner_English Learner Status`, category: 'English Learner Status', group: 'Non-English Learner' },
                { id: `${headKey}-math-trend_${dataset}_Female_Gender`, category: 'Gender', group: 'Female' },
                { id: `${headKey}-math-trend_${dataset}_Male_Gender`, category: 'Gender', group: 'Male' },
                { id: `${headKey}-math-trend_${dataset}_Non-Binary_Gender`, category: 'Gender', group: 'Non-Binary' },
                { id: `${headKey}-math-trend_${dataset}_IEP_IEP Status`, category: 'IEP Status', group: 'IEP' },
                { id: `${headKey}-math-trend_${dataset}_Non-IEP_IEP Status`, category: 'IEP Status', group: 'Non-IEP' },
                { id: `${headKey}-math-trend_${dataset}_Asian_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian' },
                { id: `${headKey}-math-trend_${dataset}_Asian/Pacific Islander (Retired Category)_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Asian/Pacific Islander (Retired Category)' },
                { id: `${headKey}-math-trend_${dataset}_Black/African American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Black/African American' },
                { id: `${headKey}-math-trend_${dataset}_Hawaiian/Pacific Islander_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Hawaiian/Pacific Islander' },
                { id: `${headKey}-math-trend_${dataset}_Latinx_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Latinx' },
                { id: `${headKey}-math-trend_${dataset}_Multiracial_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Multiracial' },
                { id: `${headKey}-math-trend_${dataset}_Native American_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Native American' },
                { id: `${headKey}-math-trend_${dataset}_Not Listed_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'Not Listed' },
                { id: `${headKey}-math-trend_${dataset}_White_Race/Ethnicity`, category: 'Race/Ethnicity', group: 'White' },
                { id: `${headKey}-math-trend_${dataset}_Non-Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Non-Temporary Living Situation' },
                { id: `${headKey}-math-trend_${dataset}_Temporary Living Situation_Temporary Living Situation Status`, category: 'Temporary Living Situation Status', group: 'Temporary Living Situation' },
            ];
            getGradeCharts(dataset);
            for (let trend of trends) {
                // @ts-ignore
                new Chart(document.getElementById(scopedId(trend.id)), getCategoryTrendConfig(dataset, trend.category, trend.group))
            }

            resolve(true);
        })
    }

    $(document).ready(function () {
        //buildTrends();
        showTrends({
            target: {
                value: 'school'
            }
        });
    });
    const unsubscribeDefaultSettings = defaultChartsSettingsStore.subscribe(settings => {
        //console.log("Default settings changed:", settings);
        initSelectedCharts(settings);
        createTrendTables(settings.trend);
    });

        function showSnapshot() {
            const $newView = $(parentScope).find(` .${headKey}-math-snapshot .tabs-list-container button[aria-posinset=${viewTypePosition}]`);
            $newView.click();


            $('#' + scopedId(`${headKey}-math-trend-select`)).removeClass("active");
            $(parentScope).find(`.${headKey}-math-school-trends, .${headKey}-math-network-trends, .${headKey}-math-district-trends`).hide();
            $(parentScope).find(`.${headKey}-math-snapshot`).show();
            $('#' + scopedId(`${headKey}-math-show-snapshot`)).addClass("active");
            setSnapshotHeight()
        }

        function showTrends(event) {
            // find which one we're coming from
            // was snapshot active?

            let selected = event.target.value;
            $('#' + scopedId(`${headKey}-math-show-snapshot`)).removeClass("active");
            $(parentScope).find(`.${headKey}-math-snapshot`).hide();
            $('#' + scopedId(`${headKey}-math-trend-select`)).addClass("active");
            $(parentScope).find(`.${headKey}-math-school-trends, .${headKey}-math-network-trends, .${headKey}-math-district-trends`).hide();
            $(parentScope).find(`.${headKey}-math-${selected}-trends`).show();

            const $newView = $(parentScope).find(` .${headKey}-math-${selected}-trends .tabs-list-container button[aria-posinset=${viewTypePosition}]`);
            
            if ($newView && $newView.length) {
                if (!isFirstTrendLoad) {
                    $newView.click();
                } else {
                    isFirstTrendLoad = false;
                }
            }
        }

    function displayTrend(value) {
        $('#' + scopedId(`${headKey}-math-show-snapshot`)).removeClass("active");
        $(parentScope).find(`.${headKey}-math-snapshot`).hide();
        $('#' + scopedId(`${headKey}-math-trend-select`)).addClass("active");
        $(parentScope).find(`.${headKey}-math-${ value }-trends`).show();
    }

    function hideTrendCharts() {
        $(parentScope).find(`div.${headKey}-math-all, div.${headKey}-math-economic,div.${headKey}-math-english,div.${headKey}-math-gender,div.${headKey}-math-grade, div.${headKey}-math-iep,div.${headKey}-math-race,div.${headKey}-math-temporary`).hide();
    }

    function setTrendChart() {
        hideTrendCharts();
        switch (selectedCategory) {
            case "ALL":
                $(parentScope).find(`div.${headKey}-math-all`).show();
                break;
            case "Race/Ethnicity":
                $(parentScope).find(`div.${headKey}-math-race`).show();
                break;
            case "Economic Disadvantage":
                $(parentScope).find(`div.${headKey}-math-economic`).show();
                break;
            case "English Learner Status":
                $(parentScope).find(`div.${headKey}-math-english`).show();
                break;
            case "Gender":
                $(parentScope).find(`div.${headKey}-math-gender`).show();
                break;
            case "Grade Level":
                $(parentScope).find(`div.${headKey}-math-grade`).show();
                break;
            case "IEP Status":
                $(parentScope).find(`div.${headKey}-math-iep`).show();
                break;
            case "Temporary Living Situation Status":
                $(parentScope).find(`div.${headKey}-math-temporary`).show();
                break;
        }
    }

        $(parentScope).find('.tabs-list-container .view-type-selector button').click(function (event) {
            // set global variable to whatever we have selected
            const $e = $(this);
            viewTypePosition = $e.attr('aria-posinset');
        });

        // Debounced resize handler that only runs when the "show snapshot" button is active
        const debounce = <T extends (...args: any[]) => void>(fn: T, wait = 180) => {
            let timer: number | undefined;
            return (...args: Parameters<T>) => {
                if (timer) {
                    window.clearTimeout(timer);
                }
                timer = window.setTimeout(() => {
                    timer = undefined;
                    try {
                        fn(...args);
                    } catch (e) {
                        console.warn('debounced handler error', e);
                    }
                }, wait);
            };
        };

        const resizeHandler = debounce(() => {
            try {
                const showSnapshotBtn = document.getElementById(scopedId(`${headKey}-math-show-snapshot`));
                // Only resize when snapshot view is active
                if (showSnapshotBtn && showSnapshotBtn.classList.contains('active')) {
                    setSnapshotHeight();
                }
            } catch (e) {
                console.warn('resizeHandler failed', e);
            }
        }, 180);

        // Attach listeners after initial rendering (this file already calls createSnapshot(); setTrendChart(); setSnapshotHeight();)
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', resizeHandler);

        // Remove listeners on unload to avoid leaks
        window.addEventListener('beforeunload', () => {
            try {
                window.removeEventListener('resize', resizeHandler);
                window.removeEventListener('orientationchange', resizeHandler);
            } catch (e) {
                /* defensive */
            }
        });
}